var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasGoogleMaps)?_c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.marker,"zoom":16}},[_c('gmap-marker',{attrs:{"position":_vm.marker}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }